/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TenantNameRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("TenantNameRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return TenantNameRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<TenantNameRegexQueryOperator>): TenantNameRegexQueryOperator {
        let obj = Object.assign(new TenantNameRegexQueryOperator(), model);
        TenantNameRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TenantNameRegexQueryOperator>): TenantNameRegexQueryOperator {
        if (!model) return null;
        return TenantNameRegexQueryOperator.newInstance(<TenantNameRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TenantNameRegexQueryOperator) {
        if (!obj) return;

        models.TenantNameRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TenantNameRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TenantNameRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.tenant_name) {
            models.Regex.fixupPrototype(this.tenant_name);
        }
    }

    /**
     * Tenant name regex pattern
     */
    tenant_name: models.Regex;

}
